import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import * as Yup from 'yup';
import { notify } from 'app/components/common/notify';
import { Button } from 'app/components/common/Button';
import { ImportJobVM } from 'app/stores/ui/admin.imports.ui.store';
import { useHistory } from 'react-router';
import routes from 'routes';
import { ImportDataType } from 'app/stores/admin.imports.store';

const newAupFormSchema = Yup.object({
	kw: Yup.string().required('KW ist erfoderlich').default(''),
}).required();

type NewAupForm = Yup.InferType<typeof newAupFormSchema>;

interface IUserEditForm {
	job: ImportJobVM;
	onClose: () => void;
}
export const AdminImportNewFitnessPdfForm = observer((props: IUserEditForm) => {
	const { adminImportsUiStore } = useStore();
	const history = useHistory();

	const handleSubmit = async () => {
		notify('Job wird gestartet', '', 'info');
		adminImportsUiStore.createNewJob(ImportDataType.fitnesspdf);
		const res = (await adminImportsUiStore.triggerJob(adminImportsUiStore.newJob!.job)) as any;
		history.push(routes.ADMINIMPORTS.getPath('job', res.id));


	};


	return (
		<>
			<Button type="button" className="button is-big" onClick={handleSubmit} >Fitness PDF Referenzen importieren</Button>
		</>
	);
});

